import { render, staticRenderFns } from "./tujuan.vue?vue&type=template&id=7b212a46&"
import script from "./tujuan.vue?vue&type=script&lang=js&"
export * from "./tujuan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports